/** Normalize keyboard event to comparable shortcut string e.g. "ctrl+enter", "f1" */
export function eventToShortcutKey(e: KeyboardEvent): string {
  const parts: string[] = [];
  if (e.ctrlKey || e.metaKey) parts.push('ctrl');
  if (e.altKey) parts.push('alt');
  if (e.shiftKey) parts.push('shift');
  let key = e.key;
  if (key === ' ') key = 'space';
  if (key.length === 1) key = key.toLowerCase();
  else key = key.toLowerCase();
  parts.push(key);
  return parts.join('+');
}

export function matchesShortcut(e: KeyboardEvent, pattern: string): boolean {
  const normalized = eventToShortcutKey(e);
  const expected = pattern.toLowerCase();
  if (normalized === expected) return true;
  // F-keys without modifiers
  if (!expected.includes('+') && e.key.toLowerCase() === expected) {
    return !e.ctrlKey && !e.altKey && !e.metaKey;
  }
  return false;
}

export function matchesAny(e: KeyboardEvent, patterns: string[]): boolean {
  return patterns.some((p) => matchesShortcut(e, p));
}
